import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useCourses, useGet: useCourse } = getCRUDHooks<{ id: number; title: string }>({
  entityName: 'course',
  withLinks: true,
  getHelper: () => clientApi.getOCClient().helpers.learningContent.courses,
});

export { useCourses, useCourse };
